/* Galerie vidéo : les vignettes YouTube ne chargent le lecteur qu'au clic
   (pas d'iframe au chargement de la page), et le script TikTok n'est
   chargé que si la page contient un bloc TikTok. */
(function () {
  document.querySelectorAll('.gallery-video[data-video-id]').forEach(function (card) {
    var button = card.querySelector('.gallery-video__play');
    if (!button) return;
    button.addEventListener('click', function () {
      var id = card.dataset.videoId;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      iframe.title = button.getAttribute('aria-label') || 'Vidéo YouTube';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.setAttribute('allowfullscreen', '');
      iframe.loading = 'eager';
      var media = card.querySelector('.gallery-video__media');
      media.innerHTML = '';
      media.appendChild(iframe);
      card.classList.add('gallery-video--playing');
    });
  });

  if (document.querySelector('.tiktok-embed') && !document.querySelector('script[src="https://www.tiktok.com/embed.js"]')) {
    var s = document.createElement('script');
    s.src = 'https://www.tiktok.com/embed.js';
    s.async = true;
    document.body.appendChild(s);
  }
})();
